import { type ReactNode } from "react";
import "./base-error-page.scss";
import clsx from "clsx";

interface BaseErrorPageProps {
  title: string;
  description: ReactNode;
  asset: ReactNode;
  className?: string;
}

export function BaseErrorPage({
  title,
  description,
  asset,
  className,
}: BaseErrorPageProps) {
  return (
    <div className={clsx("base-error-page-wrapper", className)}>
      <div className="base-error-page">
        <h1 className="base-error-page-title">{title}</h1>
        <div className="base-error-page-container">
          <div className="base-error-page-asset">{asset}</div>
          <p className="base-error-page-description">{description}</p>
        </div>
      </div>
    </div>
  );
}
